import { axiosV1 } from 'interceptors/axios';
import { Dispatch } from 'redux';
import { dispatchError } from 'utils/dispatchError';
import { decryptResponse } from 'utils/token';

export type ReplaceDocumentTagsSources = {
  society?: string;
  partner?: string;
  dividend?: string;
  sharesTitle?: string;
  tradingOfferOperation?: string;
  incentiveOfferOperation?: string;
};

type ReplaceDocumentTags = {
  documentId: string;
  sources: ReplaceDocumentTagsSources;
  language: string;
};

export const getDocumentReplacedWithTags =
  ({ documentId, sources, language }: ReplaceDocumentTags) =>
  async (dispatch: Dispatch) => {
    try {
      const { data } = await axiosV1.get('/documents/replace-tags', {
        params: { documentId, ...sources, language },
      });

      const decodedData = await decryptResponse(data);

      return decodedData;
    } catch (error) {
      dispatchError(error, dispatch);
    }
  };
